import i18n from '@locales/i18n'
import { Box, Typography, Container, Paper } from '@mui/material'

const Privacy = () => {
  return (
    <Box sx={{ mt: 2 }}>
      <Container maxWidth="lg">
        <Typography variant="h2" align="center">
          {i18n.t('SYSCOMMON.privacy')}
        </Typography>
        <Box>
          <Paper sx={{ p: 2 }}>{'no content'}</Paper>
        </Box>
      </Container>
    </Box>
  )
}

export default Privacy
